// returns the localized suffix for a given unit
import type { UNITS } from '@/app/common/measures/types.ts';
import { DISTANCE_UNITS, WEIGHT_UNITS } from '@/app/common/measures/types.ts';
import { Language } from '@/domainLogic/index.ts';

export const LOCALIZED_UNIT_NAME = {
  [DISTANCE_UNITS.KM]: {
    [Language.BG]: 'км',
    [Language.EL]: 'χμ',
    default: 'km',
  },
  [DISTANCE_UNITS.M]: {
    [Language.BG]: 'м',
    [Language.EL]: 'μ',
    default: 'm',
  },
  [DISTANCE_UNITS.M2]: {
    [Language.BG]: 'м²',
    [Language.EL]: 'μ²',
    default: 'm²',
  },
  [DISTANCE_UNITS.MI]: {
    [Language.BG]: 'ми',
    [Language.EL]: 'μίλια',
    default: 'mi',
  },
  [DISTANCE_UNITS.FT]: {
    [Language.BG]: 'фут',
    [Language.EL]: 'πόδια',
    default: 'ft',
  },
  [WEIGHT_UNITS.KG]: {
    [Language.BG]: 'кг',
    [Language.EL]: 'χγρ',
    default: 'kg',
  },
  [WEIGHT_UNITS.G]: {
    [Language.BG]: 'гр',
    [Language.EL]: 'γρ',
    default: 'g',
  },
  [WEIGHT_UNITS.LBS]: {
    [Language.BG]: 'фунта',
    [Language.EL]: 'λίβρες',
    default: 'lbs',
  },
  [WEIGHT_UNITS.OZ]: {
    [Language.BG]: 'унция',
    [Language.EL]: 'ουγγιές',
    default: 'oz',
  },
};

export const getSuffix = (unit: UNITS, language: Language): string => {
  // @ts-ignore
  const localized = LOCALIZED_UNIT_NAME?.[unit]?.[language]; // get localized unit name based on language if defined
  const def = LOCALIZED_UNIT_NAME?.[unit]?.default; // get default unit name if no localization is available

  if (localized) return localized;
  if (def) return def;
  return '';
};
